import { Component, Input } from '@angular/core'
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { Venue } from '../domain/Venue'

@Component({
    selector: 'app-unique-name-input',
    templateUrl: './unique-name-input.component.html',
})
export class UniqueNameInputComponent {

    @Input() venue?: Venue
    @Input() existingNames: string[] = []
    @Input() duplicateErrorMessage: string = 'This name has already been used. Please enter a different name.'
    
    form!: FormGroup
    
    constructor(
        public activeModal: NgbActiveModal,
        private fb: FormBuilder
    ) {
        this.form = this.fb.group({
            name: new FormControl<string>('', {
                validators: [
                    Validators.required,
                    Validators.minLength(1),
                    this.uniqueNameValidator.bind(this)
                ],
                nonNullable: true
            })
        })
    }

    private uniqueNameValidator(control: AbstractControl): ValidationErrors | null {
        const value = control.value?.trim().toLowerCase()
        if (!value) {
            return null
        }
        const isDuplicate = this.existingNames.some(
            name => name.toLowerCase() === value
        )
        return isDuplicate ? { duplicateName: true } : null
    }

    dismiss() {
        this.activeModal.dismiss()
    }

    submit() {
        if (this.form.invalid) {
            this.form.markAllAsTouched()
            return
        }
        const name = this.form.value.name.trim()
        this.activeModal.close(name)
    }

    get nameControl(): FormControl<string> {
        return this.form.get('name') as FormControl<string>
    }

    get showDuplicateError(): boolean {
        const control = this.nameControl
        return !!(control.touched && control.hasError('duplicateName'))
    }
}
